import Scroller from '../@tix02/dom/Scroller';
//import { select } from '../@tix02/utility/dom';


/*
 * Scrolling breakpoints 
 */
export default () => {
	const scrolledClassName = 'scroll-into-view';
	const body = document.body;
	const waypoints = [
		{ 
			breakpoint: 25,
			callBack: {
				UP: (/*element*/) => {
					//document.querySelector('.site-top-bar').classList.remove('min');
					body.classList.remove(scrolledClassName);
				},
				
				DOWN: (/*element*/) => {
					//document.querySelector('.site-top-bar').classList.add('min');
					body.classList.add(scrolledClassName);
				}
			}
		},
	];
	
	
	//const scroller = 
	new Scroller(waypoints);
	
	/*
	scroller.addBreakpoint({ 
		breakpoint: select('.scroll-entrance entrance--default'),
		callBack: {
			DOWN: function() {
				this.element.classList.add('shown');
			},
		},
	});
	*/
};
